<template>
  <section
    id="simpelbang"
    class="infografis-anchor-section tab-panel">

      <v-alert
        v-if="errorMessage"
        type="error"
        dense
        text
        class="mx-4 mt-2 mb-0">
        {{ errorMessage }}
      </v-alert>

      <v-card-text class="pa-0">
        <div class="section-top mb-5">
          <div class="section-top__left">
            <div class="section-chip">📈 Modul SIMPELBANG</div>
            <p class="section-lead mb-0 mt-3">
              Menampilkan ringkasan realisasi pembangunan, deviasi fisik, target bulanan, serta progres keuangan secara lebih visual.
            </p>
          </div>
          <div class="filters">
            <div class="filter-item filter-item--year">
              <label for="simpelbangYear">Tahun</label>
              <v-autocomplete
                :value="selectedYear"
                :items="yearOptions"
                dense
                placeholder="Pilih Tahun"
                single-line
                outlined
                class="filter-input"
                hide-details
                @change="$emit('update:year', $event)" />
            </div>
            <div class="filter-item filter-item--month">
              <label for="simpelbangMonth">Bulan</label>
              <v-autocomplete
                :value="selectedMonth"
                :items="monthOptions"
                item-text="label"
                item-value="value"
                dense
                placeholder="Pilih Bulan"
                outlined
                class="filter-input"
                hide-details
                @change="$emit('update:month', $event)" />
            </div>
          </div>
        </div>

        <!-- <p class="text-caption text--secondary mb-4">
          Ringkasan utama · Tahun {{ selectedYear }}, {{ selectedMonthLabel }}
        </p> -->

        <SimpelbangStats
          :loading-summary-murni="loadingSummaryMurni"
          :loading-summary="loadingSummary"
          :metric-cards-primary="metricCardsPrimary"
          :dpa-status="dpaStatus"
          :metric-cards-secondary="metricCardsSecondary" />

        <SimpelbangCharts
          :selected-year="selectedYear"
          :simpelbang-grafik-error="simpelbangGrafikError"
          :simpelbang-grafik-loading="simpelbangGrafikLoading"
          :simpelbang-has-grafik-data="simpelbangHasGrafikData"
          :simpelbang-fisik-chart-options="simpelbangFisikChartOptions"
          :simpelbang-fisik-series="simpelbangFisikSeries"
          :simpelbang-keuangan-chart-options="simpelbangKeuanganChartOptions"
          :simpelbang-keuangan-series="simpelbangKeuanganSeries" />

        <v-row class="mt-0">
          <v-col
            cols="12"
            lg="12">
            <SimpelbangMonthlyTable :grafik-rows="simpelbangGrafikRows" />
          </v-col>
        </v-row>
      </v-card-text>
  </section>
</template>

<script>
import SimpelbangCharts from '@/components/infografis/SimpelbangCharts.vue'
import SimpelbangMonthlyTable from '@/components/infografis/SimpelbangMonthlyTable.vue'
import SimpelbangStats from '@/components/infografis/SimpelbangStats.vue'

export default {
  name: 'SimpelbangSection',
  components: {
    SimpelbangCharts,
    SimpelbangMonthlyTable,
    SimpelbangStats
  },
  props: {
    selectedYear: {
      type: Number,
      required: true
    },
    selectedMonth: {
      type: Number,
      required: true
    },
    selectedMonthLabel: {
      type: String,
      default: ''
    },
    yearOptions: {
      type: Array,
      default: () => []
    },
    monthOptions: {
      type: Array,
      default: () => []
    },
    dpaStatus: {
      type: String,
      default: 'murni'
    },
    errorMessage: {
      type: String,
      default: ''
    },
    metricCardsPrimary: {
      type: Array,
      default: () => []
    },
    metricCardsSecondary: {
      type: Array,
      default: () => []
    },
    loadingSummaryMurni: {
      type: Boolean,
      default: false
    },
    loadingSummary: {
      type: Boolean,
      default: false
    },
    simpelbangGrafikError: {
      type: String,
      default: ''
    },
    simpelbangGrafikLoading: {
      type: Boolean,
      default: false
    },
    simpelbangHasGrafikData: {
      type: Boolean,
      default: false
    },
    simpelbangFisikChartOptions: {
      type: Object,
      required: true
    },
    simpelbangFisikSeries: {
      type: Array,
      default: () => []
    },
    simpelbangKeuanganChartOptions: {
      type: Object,
      required: true
    },
    simpelbangKeuanganSeries: {
      type: Array,
      default: () => []
    },
    simpelbangGrafikRows: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.infografis-anchor-section {
  scroll-margin-top: 52px;
}

@media (min-width: 600px) {
  .infografis-anchor-section {
    scroll-margin-top: 68px;
  }
}

@media (min-width: 960px) {
  .infografis-anchor-section {
    scroll-margin-top: 104px;
  }
}

.tab-panel {
  padding: 22px;
}

.section-top {
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 16px;
  flex-wrap: wrap;
}

.section-top__left {
  flex: 1 1 640px;
  min-width: 320px;
}

.section-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 800;
  color: #1757b8;
  background: rgba(23, 87, 184, 0.08);
  border: 1px solid rgba(23, 87, 184, 0.08);
  border-radius: 999px;
  padding: 8px 12px;
}

.section-lead {
  color: #6f7f92;
  font-size: 14px;
  line-height: 1.6;
  max-width: 760px;
}

.filters {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: nowrap;
  flex: 0 0 auto;
  width: auto;
  max-width: none;
}

.filter-item {
  flex: 0 0 auto;
}

.filter-item--year {
  width: 124px;
}

.filter-item--month {
  width: 168px;
}

.filter-item label {
  display: block;
  margin-bottom: 7px;
  font-size: 12px;
  color: #7d8ea4;
  font-weight: 600;
}

.filter-input::v-deep .v-input__slot {
  border-radius: 14px !important;
  min-height: 36px !important;
  border-color: rgba(22, 50, 79, 0.16) !important;
}

.filter-input::v-deep .v-input__append-inner {
  margin-top: 6px;
}

.filter-input::v-deep .v-input__control {
  min-height: 36px;
}

.filter-input::v-deep input {
  font-size: 13px;
}

@media (max-width: 720px) {
  .tab-panel {
    padding: 16px;
  }

  .filters {
    width: 100%;
    max-width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .section-top__left {
    flex: 1 1 100%;
    min-width: 0;
  }

  .filter-item {
    flex: 1 1 100%;
    min-width: 0;
  }

  .filter-item--year,
  .filter-item--month {
    width: 100%;
  }
}
</style>
